// extracted by mini-css-extract-plugin
export var bubble = "_25-0";
export var container = "_25-f";
export var contrastBorder = "_25-g";
export var greyOut = "_25-2";
export var initialsColor0 = "_25-3";
export var initialsColor1 = "_25-4";
export var initialsColor10 = "_25-d";
export var initialsColor11 = "_25-e";
export var initialsColor2 = "_25-5";
export var initialsColor3 = "_25-6";
export var initialsColor4 = "_25-7";
export var initialsColor5 = "_25-8";
export var initialsColor6 = "_25-9";
export var initialsColor7 = "_25-a";
export var initialsColor8 = "_25-b";
export var initialsColor9 = "_25-c";
export var initialsWrapper = "_25-1";
export var large = "_25-l";
export var medium = "_25-k";
export var mediumSmall = "_25-j";
export var mediumSmallMedium = "_25-o";
export var micro = "_25-h";
export var small = "_25-i";
export var tiny = "_25-n";
export var xTiny = "_25-m";